export const PERSONAL_AREA = {
  LABEL: 'personal.personal_information',
  PERSONAL: '458730d9-39bb-477d-a5cd-ece4d39741e4',
  FOREIGN: '726680d9-7491-4926-9c50-7421303ee337',
  BANK_ACCOUNTS: '192301a5-6577-4ed0-b4ae-f5823e3f1d31',
  EDUCATIONS: '8943ac35-d9f4-4df7-844c-a80456a3da00',
  HANDICAP: '2acc854c-e4db-4828-9807-aa2e27e0df71',
}

export const PROFESSIONAL_AREA = {
  LABEL: 'professional.professional_information',
  JOB_INFO: '22d3f1d4-7b71-422a-be8b-59a8997012b3',
  INTERN: 'b8c76b98-b10a-43ec-97e8-cfd7b352ae3c',
  UNION_CONTRIBUTIONS: '3aee6b5c-5729-45cc-92e7-26d3d87d616b',
  SALARY_LINK: '7766eacc-d5be-4c8f-b670-48a17acd00ac',
  WORK_JOURNEY: 'd23b3395-9514-4e42-90a3-10479bff74a0',
  ACCOUNTANTY: 'fdcc9eb8-c2a2-4f44-bce9-589af4b3a007',
}

export const ADDRESSES_CONTACTS_AREA = {
  LABEL: 'personal.addresses_contacts',
  ADDRESS: 'dbf9e928-2e39-4583-9ebe-ef14b5094eb4',
  CONTACTS: '796453df-01ed-40bb-9364-7b6f272f803e',
  EMERGENCY_CONTACTS: '608527f9-5469-44ef-b246-54609f0d4c09'
}

export const DEPENDENTS_AREA = {
  LABEL: 'personal.dependant',
  DEPENDENTS: '7e04b405-747c-4e7e-a575-44f1feb34e71',
}

export const PERSONAL_DOCUMENTS_AREA = {
  LABEL: 'documents.personal_documents',
  CNH: '7f0e3b95-bab2-4f7e-b4fb-34a4d3a92794',
  CTPS: '1dd72199-68e9-4a64-b57b-3844a8fb9488',
  CPF: 'eb8e3dcf-6d45-4554-8f1e-cb721dbd05bc',
  RESERVIST: '8459053d-7a96-461e-a28d-b72d90f7e95e',
  RG: '9831bcd4-21c7-4d45-a8a4-b95435e61511',
  ELECTORAL: 'dfa25607-f8f5-4d5d-bf64-f1f8563dfcb7',
}

export const ABSENCES_AREA = {
  LABEL: 'professional.absences',
  ABSENCES: 'b4bafbfa-138a-4302-a629-ad9609e0b0b9',
}
